import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 17l-18 0","key":"svg-0"}],["path",{"d":"M18 4l3 3l-3 3","key":"svg-1"}],["path",{"d":"M18 20l3 -3l-3 -3","key":"svg-2"}],["path",{"d":"M21 7l-18 0","key":"svg-3"}]]

const IconArrowsRight = createReactComponent('outline', 'arrows-right', 'ArrowsRight', __iconNode);

export default IconArrowsRight;